/**
 * Parse URL
 * @author Ryan Gladstone
 */

function urlService($location, moment, timezoneService) {
  const service = {};

  service.getEpochTime = (date, dateValue) => {
    if (typeof date === 'string') {
      const dateArg = date.toLowerCase();

      if (dateArg === 'yesterday') {
        return moment()
          .tz(timezoneService.userTimezone)
          .add(-1, 'days')
          .startOf('day')
          .unix();
      }

      if (dateArg === 'today') {
        if (dateValue && typeof dateValue === 'number') {
          return moment(dateValue)
            .tz(timezoneService.userTimezone)
            .startOf('day')
            .unix();
        }

        return moment().tz(timezoneService.userTimezone).startOf('day').unix();
      }

      if (dateArg === 'endofday') {
        if (dateValue && typeof dateValue === 'number') {
          return moment(dateValue)
            .tz(timezoneService.userTimezone)
            .endOf('day')
            .unix();
        }

        return moment().tz(timezoneService.userTimezone).endOf('day').unix();
      }

      if (dateArg === 'yesterdayfromnow') {
        if (dateValue && typeof dateValue === 'number') {
          return moment(dateValue)
            .tz(timezoneService.userTimezone)
            .add(-1, 'days')
            .unix();
        }

        return moment().tz(timezoneService.userTimezone).add(-1, 'days').unix();
      }

      if (dateArg === 'tomorrowfromnow') {
        if (dateValue && typeof dateValue === 'number') {
          return moment(dateValue)
            .tz(timezoneService.userTimezone)
            .add(1, 'days')
            .unix();
        }

        return moment().tz(timezoneService.userTimezone).add(1, 'days').unix();
      }

      if (dateArg === 'now') {
        if (dateValue && typeof dateValue === 'number') {
          return moment(dateValue).tz(timezoneService.userTimezone).unix();
        }
        return moment().tz(timezoneService.userTimezone).unix();
      }

      if (dateArg === 'tomorrow') {
        return moment()
          .tz(timezoneService.userTimezone)
          .add(1, 'days')
          .startOf('day')
          .unix();
      }

      if (dateArg === 'empty') {
        return null;
      }

      if (dateArg.match(/[+-][\d\W]+[^\d\W]+/)) {
        return moment()
          .add(
            parseInt(dateArg.match(/[+-][\d\W]+/)[0], 10),
            dateArg.match(/[^\d\W]+/)[0]
          )
          .unix();
      } else if (dateArg.toString().match(/[+-][\d\W]+$/)) {
        const newDate = timezoneService.getTzDate(new Date());
        newDate.setSeconds(newDate.getSeconds() + parseInt(dateArg, 10));
        return newDate.getTime() / 1000;
      }

      return isNaN(parseInt(dateArg, 10)) ? null : parseInt(dateArg, 10);
    } else if (typeof date === 'number') {
      return date;
    }

    return date;
  };

  const isInt = n => n % 1 === 0;

  service.locationEdit = (propstringOrObj, val) => {
    const loc = $location.search();

    if (typeof propstringOrObj === 'string') {
      loc[propstringOrObj] = val;
    } else if (typeof propstringOrObj === 'object') {
      angular.extend(loc, propstringOrObj);
    }

    $location.search(loc);
  };

  service.relativeNumericToAlpha = (value) => {
    const sign = value > 0 ? '+' : '-';
    let unit = 'hours';
    const rawTimeOffset = Math.abs(value) * 1000;

    if (isInt(moment.duration(rawTimeOffset).as('weeks'))) {
      unit = 'weeks';
    } else if (isInt(moment.duration(rawTimeOffset).as('days'))) {
      unit = 'days';
    }

    return sign + moment.duration(rawTimeOffset).as(unit) + unit;
  };

  service.relativeAlphaToNumeric = (value) => {
    if (value.indexOf('-') === 0 || value.indexOf('+') === 0) {
      return moment
        .duration(
          parseInt(value.match(/[+\-\d\W]+/)[0], 10),
          value.match(/[^+\-\d\W]+/)[0]
        )
        .asSeconds();
    }
    return '';
  };

  return service;
}

const arr = ['$location', 'moment', 'timezoneService', urlService];

module.exports = (ngModule) => {
  ngModule.service('urlService', arr);
};
